import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { AuthService } from './auth.service';

import * as DeviceDetector from 'device-detector-js';

import { environment } from '../../environments/environment';

declare const lifecycle: any;

@Injectable()
export class AnalyticsService {
  apiUrl = environment.apiUrl;

  constructor(private http: HttpClient, private authService: AuthService) {
    this._onUserVisited();
  }

  private _addLifecycleListener() {
    lifecycle.addEventListener('statechange', event => {
      switch (event.newState) {
        case 'active': {
          const analyticsId = sessionStorage.getItem('analytics-session-id');
          if (analyticsId) {
            const data = new FormData();
            data.append('analyticsId', analyticsId);
            navigator.sendBeacon(`${this.apiUrl}/analytics/user-active`, data);
          }
          break;
        }
        case 'hidden': {
          const analyticsId = sessionStorage.getItem('analytics-session-id');
          if (analyticsId) {
            const data = new FormData();
            data.append('analyticsId', analyticsId);
            navigator.sendBeacon(`${this.apiUrl}/analytics/user-inactive`, data);
          }
          break;
        }
        case 'terminated': {
          const analyticsId = sessionStorage.getItem('analytics-session-id');
          if (analyticsId) {
            const data = new FormData();
            data.append('analyticsId', analyticsId);
            navigator.sendBeacon(`${this.apiUrl}/analytics/user-left`, data);
          }
          break;
        }
      }
    });
  }

  private _sendUserVisited(data) {
    return this.http.post(`${this.apiUrl}/analytics/user-visited`, data).pipe(
      catchError(err => {
        return ErrorObservable.create('Error sending user visited');
      })
    );
  }

  private _onUserVisited() {
    const deviceDetector = new DeviceDetector();
    const device = deviceDetector.parse(navigator.userAgent);
    const data = new FormData();
    data.append('device', JSON.stringify(device));
    this._sendUserVisited(data)
      .pipe(
        map((res: any) => {
          // console.log('res', res);
          sessionStorage.setItem('analytics-session-id', res.data.id);
          this._addLifecycleListener();
          const userId = this.authService.getUserId();

          if (userId) {
            this.onUserLoggedIn(userId);
          }
        })
      )
      .subscribe();
  }

  onUserLoggedIn(userId) {
    const analyticsId = sessionStorage.getItem('analytics-session-id');
    if (analyticsId && userId) {
      const data = new FormData();
      data.append('analyticsId', analyticsId);
      data.append('userId', userId);
      navigator.sendBeacon(`${this.apiUrl}/analytics/user-logged-in`, data);
    }
  }

  onUserLoggedOut() {
    const analyticsId = sessionStorage.getItem('analytics-session-id');
    if (analyticsId) {
      const data = new FormData();
      data.append('analyticsId', analyticsId);
      navigator.sendBeacon(`${this.apiUrl}/analytics/user-logged-out`, data);
    }
  }

  onUserChoosedScene(sceneName, sceneId) {
    const analyticsId = sessionStorage.getItem('analytics-session-id');
    if (analyticsId) {
      const data = new FormData();
      data.append('analyticsId', analyticsId);
      data.append('sceneName', sceneName);
      data.append('sceneId', sceneId);
      navigator.sendBeacon(`${this.apiUrl}/analytics/user-chosen-scene`, data);
    }
  }

  onUserSharedProject(projectId) {
    const analyticsId = sessionStorage.getItem('analytics-session-id');
    if (analyticsId) {
      const data = new FormData();
      data.append('analyticsId', analyticsId);
      data.append('projectId', projectId);
      navigator.sendBeacon(`${this.apiUrl}/analytics/user-shared-project`, data);
    }
  }

  onUserCreatedQuote(projectId, dealerSelected, userComments) {
    const analyticsId = sessionStorage.getItem('analytics-session-id');
    if (analyticsId) {
      const data = new FormData();
      data.append('analyticsId', analyticsId);
      data.append('projectId', projectId);
      data.append('dealerSelectedId', dealerSelected.id);
      data.append('dealerSelectedName', dealerSelected.values.companyname);
      data.append('dealerSelectedUrl', dealerSelected.values.url);
      data.append('userComments', userComments);
      navigator.sendBeacon(`${this.apiUrl}/analytics/user-created-quote`, data);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/analytics.service.ts